import { React, Link,} from "react-router-dom";
import HeroSection from "../components/homepage/HeroSection";
import PropertyByCity from "../components/homepage/PropertyByCity";
import Offer from "../components/homepage/Offer";
import Type from "../components/homepage/Type";
import AboutUs from "../components/homepage/AboutUs";
import AboutUsTwo from "../components/homepage/AboutUs2";
import AddedToday from "../components/homepage/AddedToday";
import HowItWorks from "../components/homepage/HowItWorks";
import InfoBar from "../components/homepage/InfoBar";
import { Helmet } from "react-helmet";
import BlogListSection from "../admin/dashboard/blog/blogHome/BlogListSection";
import SocialMedia from "../admin/dashboard/social-media/SocialMedia";
import PromoBanner from "../admin/dashboard/banner/PromoBanner";
import HomeFooter from "../components/common/Home_footer";

function HomePage() {
  return (
    <div className="home-page">
      <Helmet>
        <title>
          Find Your Dream Home – Buy or Rent with All Home Desire | Properties
          Online
        </title>
        <meta
          name="description"
          content="Discover Your Dream Property in India with All Home Desire - The Best Site for Buying, Selling, and Renting Residential and Commercial Real Estate"
        />
        <meta
          name="keywords"
          content="real estate, property in India, properties, property sites India, apartments near me, apartments for rent, houses for sale near me, homes for sale near me, apartments, apartments for rent near me, sell my house, houses for sale, we buy houses, houses for rent near me, sell my house fast, homes for sale"
        />
      </Helmet>
      <Link
        variant="primary"
        size="lg"
        className="btn btn-primary btn-lg position-fixed bottom-0 end-0 z-3 mb-3 me-3"
        
        to={"/partnerreg"}
      > 
        Become A Partner
      </Link>
      <HeroSection />
      <PropertyByCity />
      <BlogListSection />
      <Type />
      <Offer />
      <AboutUs />
      <AddedToday /> 
      <AboutUsTwo />
      <HowItWorks />
      <InfoBar />
      <SocialMedia/>
      <PromoBanner/>
      <HomeFooter/>
    </div>
  ); 
}

export default HomePage;
